<template>
  <div class="clearfix">
    <div class="main-content clearfix">
      <div class="row">
        <div class="col-xs-12">
          <div class="row p-b-sm table-filter">
            <div class="col-sm-2 col-xs-12 ">
              <h4 class="table-name">岗位管理</h4>
            </div>
            <div class="col-sm-3 col-xs-6 ">
              <div class="row">
                类型:
                <input type="checkbox" name="post_category" value="2" v-model="filter.post_category" id="post_category-company">
                <label for="post_category-company">企业</label>
                <input type="checkbox" name="post_category" value="1" v-model="filter.post_category" id="post_category-system">
                <label for="post_category-system">系统</label>
              </div>
            </div>
            <div class="col-sm-3 col-xs-6 ">
              <div class="row">
                <input type="checkbox" v-model="filter.isMy" id="is_my" :true-value="1" :false-value="0">
                <label for="is_my">只看我的</label>
              </div>
            </div>
            <div class="col-xs-12 col-sm-4">
              <div class="row">
                <div class="col-sm-6 col-xs-12">
                  <input type="text" class="input input-sm" placeholder="输入岗位名称进行搜索" required="required" v-model.trim="filter.search" autocomplete="off" @keyup.enter="reload()">
                </div>
                <div class="col-sm-6 col-xs-12">
                  <div class="row">
                    <div class="col-xs-6 n-p-l">
                      <button type="button" class="btn btn-sm btn-primary col-xs-12" @click="reload()">搜&nbsp;索</button>
                    </div>
                    <div class="col-xs-6 n-p-l">
                      <router-link class="btn btn-sm btn-primary col-xs-12 text-center" to="/company/posts/add" tag="a">新&nbsp;增</router-link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-xs-12">
              <table class="table table-border">
                <thead>
                  <tr>
                    <th>序号</th>
                    <th>岗位名称</th>
                    <th>能力群</th>
                    <th>指标</th>
                    <th>题量</th>
                    <th>测评次数</th>
                    <th>类型</th>
                    <th v-if="filter.isMy===0">创建人</th>
                    <th>操作</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(post,ind) in posts" :key="post._id">
                    <td>{{filter.start + ind+1}}</td>
                    <td>
                      <span class="left">{{post.name}}</span>
                      <div class="left tooltips" v-if="post.alias">
                        <i class="fa fa-info-circle"></i>
                        <div class="text">
                          别名：<br> {{post.alias}}
                        </div>
                      </div>
                    </td>
                    <td>{{post.abilities.length}}</td>
                    <td>{{post.indicators.length}}</td>
                    <td>{{post.questions_num}}</td>
                    <td>{{post.evaluate_num}}</td>
                    <td>{{post.post_category === 1 ? '系统':'企业'}}</td>
                    <td v-if="filter.isMy===0">{{post.post_category === 1 ? '系统': (post.post_owner?(post.post_owner.realname):'企业')}}</td>
                    <td>
                      <router-link class="btn btn-primary btn-xs" :to="{name:'/company/posts/show',params:{'_id':post._id}}">查看</router-link>
                      <router-link class="btn btn-warning btn-xs" :to="{name:'/company/posts/edit',params:{'_id':post._id}}" v-if="post.post_category === 2 &&( user.category === 2 || ((user.role === 2|| user.role === 3) && post.post_owner && post.post_owner._id  === user._id))">编辑</router-link>
                      <span class="btn btn-danger btn-xs" @click="del(post,ind)" v-if="post.post_category === 2 &&(user.category === 2 || ((user.role === 2|| user.role === 3) && post.post_owner && post.post_owner._id  === user._id))">删除</span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="row">
            <div class="col-xs-12">
              <pagination :current="filter.current" :length="filter.length" :total="filter.total" :page-click="go"></pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { deepCopy } from "../../../plugins/utils";
import Post from "../../../resource/post";
import Loading from "../../blocks/loading.vue";
export default {
  components: { Loading },
  data: function() {
    return {
      loading: 1,
      posts: [],
      filter: {
        status: 0,
        search: "",
        current: 1,
        length: 20,
        start: 0,
        total: 0,
        isMy: 0,
        category: 2, // 岗位
        post_category: [1, 2]
      }
    };
  },
  computed: {
    ...mapGetters({
      user: "loginUser"
    })
  },
  created: function() {
    let that = this;
    if (
      that.user.category === 2 ||
      that.user.role === 2 ||
      that.user.role === 3
    ) {
      document.title = `岗位管理-企业控制台|${that.global.name}`;
    } else {
      that.$router.replace("/");
    }
  },
  watch: {
    "filter.status": function() {
      let that = this;
      that.reload();
    },
    "filter.post_category": function() {
      let that = this;
      that.reload();
    },
    "filter.isMy": function() {
      let that = this;
      that.reload();
    }
  },
  methods: {
    loadPosts: function() {
      let that = this;
      that.filter.start =
        (Number(that.filter.current) - 1) * Number(that.filter.length);
      let _opts = deepCopy(that.filter);
      _opts.post_category =
        that.filter.post_category.length == 1
          ? that.filter.post_category[0]
          : 0;
      Post.page(_opts).then(
        res => {
          let data = res.body;
          if (data.code === 0) {
            that.posts = data.result.results || [];
            that.filter.total = data.result.count;
          } else {
            alert(data.msg);
          }
        },
        res => {}
      );
    },
    reload: function() {
      let that = this;
      that.go(1);
    },
    go: function(page) {
      let that = this;
      that.filter.current = page;
      that.loadPosts();
    },
    del: function(post, ind) {
      let that = this;
      if (post.invite_num > 0) {
        alert("岗位正在使用中不能删除");
      } else {
        if (confirm(`您要删除岗位“${post.name}”吗？删除后不可使用`)) {
          Post.delete({ _id: post._id }).then(
            res => {
              let data = res.body;
              if (data.code === 0) {
                that.posts.splice(ind, 1);
                alert(`岗位“${post.name}”已删除`);
              } else {
                alert(data.msg);
              }
            },
            res => {}
          );
        }
      }
    }
  },
  mounted: function() {
    let that = this;
    that.loadPosts(); // 载入岗位
  }
};
</script>
<style lang="less" scoped>
.invitate-code {
  padding-left: 15px;
  padding-right: 15px;
  &.code_is_active {
    color: #42b983;
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 1s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// list.vue?51c2b957